import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import ApplicationCard from '../applications/ApplicationCard';
import BasicLayout from '../BasicLayout';
import { globalStyles as styles } from '../style/gstheme';

class AdministrationApplications extends React.Component {

  render() {

    const { user } = this.props;

    return (
      <BasicLayout title="Administration">
        <Grid spacing={2} container justifyContent="space-evenly" classes={
          {
            "spacing-xs-2": this.props.classes.fullGrid
          }
        }>
          <Grid item>
            <ApplicationCard
              dataTest="system-statistics-card"
              id="systemstatistics"
              url="/administration/systemstatistics"
              title="System Statistics"
              description="View statistics on the Graphologi system"
              thumbnail="/images/systemstats.svg"
            />
          </Grid>
          {user.systemAdmin &&
            <Grid item>
              <ApplicationCard
                dataTest="system-control-card"
                id="systemcontrol"
                url="/administration/systemcontrol"
                title="System Control"
                description="Control the GrafSync system"
                thumbnail="/images/dashboard.svg"
              />
            </Grid>
          }
          <Grid item>
            <ApplicationCard
              dataTest="user-management-card"
              id="usermanagement"
              url="/administration/usermanagement"
              title="User Management"
              description="Manage users"
              thumbnail="/images/groups.svg"
            />
          </Grid>
        </Grid>
      </BasicLayout>
    );
  }
}

AdministrationApplications.propTypes = {
  classes: PropTypes.object,
  user: PropTypes.object
};

export default withStyles(styles)(AdministrationApplications);